module.exports = __webpack_public_path__ + "static/media/movePortoIcon.4fe6dde8.svg";